import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { SITE } from "../data/site";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/5bf490e4-45b1-4c97-a306-51a2a86a86a7/images/76d9f483cf002efa8dc6b45634164dc2624c7b0d923f8b9b882c59690a0bc82b.png";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden flex flex-col justify-end"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt=""
          className="w-full h-full object-cover opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black" />
      </div>

      <div className="relative max-w-7xl mx-auto w-full px-6 md:px-12 pb-16 md:pb-24 pt-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="flex items-center gap-3 mb-8 md:mb-12"
        >
          <span className="w-10 h-px bg-[#f5e6d3]" />
          <span className="font-display text-xs uppercase tracking-[0.3em] text-[#f5e6d3]">
            Portfolio / {new Date().getFullYear()}
          </span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          data-testid="hero-name"
          className="font-display uppercase leading-[0.85] tracking-tighter text-[18vw] md:text-[12vw] lg:text-[10vw]"
        >
          Mohamad
          <br />
          <span className="italic font-editorial font-light text-[#f5e6d3] normal-case lowercase tracking-tight">
            hama.
          </span>
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-10 md:mt-16 grid md:grid-cols-12 gap-8 items-end"
        >
          <div className="md:col-span-7">
            <p className="font-body text-base md:text-xl text-zinc-300 leading-relaxed max-w-xl">
              {SITE.tagline}
            </p>
          </div>
          <div className="md:col-span-5 md:text-right space-y-2">
            <div className="font-display text-xs uppercase tracking-[0.25em] text-zinc-500">
              Based in
            </div>
            <div className="font-display text-lg md:text-xl uppercase">
              {SITE.location}
            </div>
            <div className="font-editorial italic text-base text-[#f5e6d3]">
              {SITE.experience} of building the web
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.7 }}
          className="mt-12 flex flex-wrap items-center gap-4"
        >
          <button
            data-testid="hero-cta-work"
            onClick={() => scrollTo("work")}
            className="group font-display text-xs uppercase tracking-[0.25em] bg-[#f5e6d3] text-black px-7 py-4 rounded-full hover:bg-white transition-colors inline-flex items-center gap-3"
          >
            See selected work
            <ArrowDown
              size={14}
              className="transition-transform group-hover:translate-y-1"
            />
          </button>
          <button
            data-testid="hero-cta-contact"
            onClick={() => scrollTo("contact")}
            className="font-display text-xs uppercase tracking-[0.25em] border border-white/20 px-7 py-4 rounded-full hover:border-white hover:bg-white/5 transition-colors"
          >
            Start a project
          </button>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 1 }}
        className="absolute bottom-6 right-6 md:right-12 flex flex-col items-center gap-3 text-zinc-500"
      >
        <span className="font-display text-[10px] uppercase tracking-[0.3em] rotate-90 origin-bottom translate-y-6">
          Scroll
        </span>
        <span className="w-px h-12 bg-zinc-700 animate-pulse" />
      </motion.div>
    </section>
  );
}
